__webpack_require__.p = "/_resources/app/client/dist/scripts/";